import React, { useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import MobileIcon from '../assets/img/mobile.svg';
import BackIcon from '../assets/img/back-btn.svg';

function ForgetDan() {
  const navigate = useNavigate(); 
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRegister = useCallback(async () => {
    if (!mobile || mobile.length !== 11 || !/^09\d{9}$/.test(mobile)) {
      alert('لطفاً یک شماره موبایل معتبر وارد کنید');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://app.doneapp.ir/backend/forget.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
           mobile: mobile,
           step: 1

         }),
      });

      if (!response.ok) throw new Error('خطا در دریافت پاسخ از سرور');

      const result = await response.json();
      if (result.status === 'success') {
        localStorage.setItem('mobile', mobile);
        navigate('/forget-otp', { state: { mobile } });
      } else {
        alert(result.message);
      }
    } catch (err) {
      alert(err.message || 'خطا در ارتباط با سرور');
    } finally {
      setLoading(false);
    }
  }, [mobile, navigate]);

  return (
    <div className="start-bdy">
      <button className="back-btn-1" onClick={() => navigate("/login")}>
        <img src={BackIcon} alt="back" />
      </button>

      <div className="logomotion tw-200">
        <div className="start-logo">
          <img src={DanLogo} alt="Dan Logo" />
          <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
        </div>
      </div>

      <div className="loginbtns-2">
        <div className="btndiv-1">
          <div className="forget-title-1">
            جهت بازیابی رمز عبور شماره خود را وارد نمایید
          </div>

          <div className="mobileinputdiv-1">
            <img className="mobileicon-1" src={MobileIcon} alt="Mobile Icon" />
            <input
              className="mobileinput-1"
              type="number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
              placeholder="شماره موبایل خود را وارد کنید"
            />
          </div>

          <button type="submit" className="loginbtn-1" onClick={handleRegister} disabled={loading}>
            {loading ? "در حال ارسال..." : "دریافت پیامک رمز عبور"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgetDan;
